"use strict";

export const dataTablesDefault = {
  buttons: {
    dom: {
      button: {
        className: 'btn btn-sm btn-light fw-semibold dropdown-toggle'
      },
      container: {
        className: 'btn-toolbar'
      },
    },
    buttons: [
      {
        extend: 'colvis',
        titleAttr: 'Column visibility',
        text: 'Column visibility',
        background: false,
        fade: 0,
        prefixButtons: [
          {
            text: 'Select all',
            init: function( dt, node ) {
              var column = dt.columns().visible().toArray();
              // Set the initial state of the "Select all"
              $( node ).toggleClass( 'dt-button-active', column.every( Boolean ) );
              $( node ).toggleClass( 'indeterminate', !column.every( Boolean ) && column.some( Boolean ) );
            },
            action: function( e, dt ) {
              var column = dt.columns().visible().toArray();
              // Toggle visibility of all columns based on their current state
              dt.columns().visible( !column.every( Boolean ) );
              $( dt.table().container() ).find( '.select-all' ).removeClass( 'indeterminate' );
              $( dt.table().container() ).find( '.select-all' ).toggleClass( 'dt-button-active', !column.every( Boolean ) );
            },
            className: 'buttons-columnVisibility select-all'
          }
        ],
      },
      {
        extend: 'csvHtml5',
        text: '<span class="svg-icon svg-icon-3 me-1"><svg class="icon-download"><use xlink:href="#icon-download"></use></svg></span> Export',
        exportOptions: {
          columns: 'thead th:not(.no-export)',
          format: {
            body: function( data, row, column, node ) {
              if( typeof $( node ).data( 'val' ) !== 'undefined' ) {
                data = $( node ).data( 'val' );
              } else {
                data = data.replace( /(<([^>]+)>)/ig, '' ).trim();
                data = data.replace( /<br\s*\/?>/ig, '\r\n' );
                data = data.replace( /<.*?>/g, '' );
                data = data.replace( '&amp;', '&' );
                data = data.replace( '&nbsp;', '' );
                data = data.replace( '&nbsp;', '' );
              }
              return data;
            }
          }
        }
      }
    ]
  },
  dom:
  "<'row invisible'" +
    "<'col-md-12 col-lg-6 d-flex align-items-center justify-content-center justify-content-lg-start mb-4'f>" +
    "<'col-md-12 col-lg-6 d-flex align-items-center justify-content-center justify-content-lg-end mb-4'B>" +
  ">" +
  "<'row invisible d-flex flex-fill flex-column'" +
    "<'table-responsive d-flex flex-fill flex-column'rt>" +
  ">" +
  "<'row invisible'" +
    "<'col-md-12 col-lg-5 d-flex align-items-center justify-content-center justify-content-lg-start mt-4'i>" +
    "<'col-md-12 col-lg-7 d-flex align-items-center justify-content-center justify-content-lg-end mt-4'lp>" +
  ">",
  language: {
    lengthMenu: 'Display &nbsp; _MENU_',
    search: 'Search ',
    paginate: {
      first: '<i class="kt-outline kt-double-left"></i>',
      last: '<i class="kt-outline kt-double-right"></i>',
      next: '<i class="next"></i>',
      previous: '<i class="previous"></i>'
    },
    processing: '<span class="loader"><span class="spinner-border h-15px w-15px align-middle text-primary"></span><span class="text-gray-800 fw-medium ms-4">Please wait..</span></span>'
  },
  lengthMenu: [ [ 20, 50, -1 ], [ 20, 50, 'All' ] ],
  destroy: true,
  order: [],
  responsive: true,
  autoWidth: false,
  pagingType: 'simple_numbers',
  renderer: 'bootstrap',
  rowGroup: {
    enable: false,
  },
  initComplete: function(){
    var api = this.api(),
        $node = $( api.table().node() ),
        $searchInput = $( api.table().container() ).find( '.dt-search input' ),
        tabSkipSelector = $node.data( 'tab-skip-to' );
    $node.hasClass( 'enable-rowgroup' ) ? api.rowGroup().enable().draw() : null;
    $( api.table().container() ).prev().fadeOut( 300 );
    setTimeout( function(){
      $( api.table().container() ).find( '.invisible' ).fadeIn( 300, function(){
        $( this ).removeClass( 'invisible' );
      } ).promise().done( function(){
        if( $node.data( 'autofocus-search' ) ){
          $searchInput.trigger( 'focus' );
        }
      } );
    } );
    $( '[data-bs-toggle="tooltip"]' ).tooltip();

    if( tabSkipSelector ) {
      $searchInput.on( 'keydown', function( e ){
        if( e.key !== 'Tab' || e.shiftKey ) return;

        var $target = $( tabSkipSelector ),
            $targetInput;

        if( $target.is( 'table' ) && $.fn.dataTable.isDataTable( $target[ 0 ] ) ){
          $targetInput = $( $target.DataTable().table().container() ).find( '.dt-search input' );
        } else if( $target.is( 'input' ) ){
          $targetInput = $target;
        } else {
          $targetInput = $target.find( 'input' ).first();
        }

        if( !$targetInput.length ) return;

        e.preventDefault();
        $targetInput.trigger( 'focus' );
      } );
    }
  },
  drawCallback: function() {
    $( '[data-bs-toggle="tooltip"]' ).tooltip();
  },
};
